import React from "react";
import useProduct from "../../../../Hook/useProduct";
import { Link } from "react-router-dom";
import Rating from "@mui/material/Rating";
import Button from "@mui/material/Button";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const LadiesFashion = () => {
  const { categories } = useProduct(
    `https://rocky-earth-23971.herokuapp.com/products?categories=${"ladies-fashion"}`
  );
  return (
    <div className="container my-5">
      <div className="row">
        <p className="text-muted my-3">
          এক্সপোর্ট এবং ইমপোর্ট ২ প্রকারের পোশাকই থাকবে আয়েশ ফ্যাশন এ। সেই সঙ্গে
          আয়েশ লেডিস ফ্যাশনে থাকবে দেশী ফ্যাশন ডিজাইনার দিয়েে আয়েশের তৈরি পণ্যও।
          ফলে লেডিস ফ্যাশনে আমরা রেখেছি- *ফেব্রিক্স *থ্রি-পিস *ওয়ান-পিস *টু-পিস
          *ওড়না *জিনস *গ্যাবাডিং *পালাজ্জু *টি-শার্ট *শার্ট *ফতুয়া *টপস
          *লেহেঙ্গা *শাড়ি *ব্লাউজ *পেটিকোট *ম্যাক্সি *নাইটি *আন্ডার গার্মেন্টস
          *সেমিজ *হিজাব *বোরখা *শীতের পোশাক
        </p>
        <p>
          ## এছাড়া বিভিন্ন সব বিখ্যাত ব্রান্ডের পণ্যের সাইজ আর কালার বলে দিলে বা
          ছবি পাঠালে কুরিয়ার সার্ভিসে পৌছে দেয়া হবে আয়েশের ভোক্তাদের
        </p>
      </div>
      <div className="row g-4">
        <hr />
        <p className="text-center display-6 text-muted">Ladies Fashion</p>
        <hr />
        {categories.map((data) => (
          <div className="col-sm-6 col-md-4 col-lg-3" key={data._id}>
            <div className="card h-100">
              <div className="card p-2  shadow">
                <img src={data.imageFile} alt="imageFile" height="200" />
              </div>
              <div className="p-3">
                <Link to="/">
                  <h5 className="text-capitalize mt-3">{data.productTitle}</h5>
                </Link>
                <div className="my-3">
                  <Rating name="read-only" value={3} readOnly />
                </div>
                <div className="d-flex justify-content-between">
                  <Button variant="contained">Add to cart</Button>
                  <Button variant="outlined">
                    <FavoriteBorderIcon />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LadiesFashion;
